import { default as _47app_47pages_47_91_46_46_46slug_93_46vueMeta } from "/app/pages/[...slug].vue?macro=true";
export default [
  {
    name: _47app_47pages_47_91_46_46_46slug_93_46vueMeta?.name ?? "slug",
    path: _47app_47pages_47_91_46_46_46slug_93_46vueMeta?.path ?? "/:slug(.*)*",
    file: "/app/pages/[...slug].vue",
    children: [],
    meta: _47app_47pages_47_91_46_46_46slug_93_46vueMeta,
    alias: _47app_47pages_47_91_46_46_46slug_93_46vueMeta?.alias || [],
    redirect: _47app_47pages_47_91_46_46_46slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/app/pages/[...slug].vue").then(m => m.default || m)
  }
]